export default "/images/_Elementis.webp?cfca335c87059a463fcc1902178e5a27";